export const DATA_HOOKS = {
  withdrawJoinRequestConfirmationButton:
    'withdraw join request confirmation button',
};
